import React, { useState } from "react";
import Modal from "react-modal";
import "../css/SelectJobModal.css";

const RequestPassword = ({ theme, isOpen, setIsOpen, returnData }) => {

    const [value, setValue] = useState("");
    const [error, setError] = useState("");

    // Handle Enter key press to trigger the form submit
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSubmit(); // Trigger form submit when Enter is pressed
        }
    };

    const handleSubmit = async () => {
        if (!value) {
            setError("No value entered!");
        } else {
            setError("");

            returnData(value); // Return the value to the parent component
            setIsOpen(false); // Close the modal
        }
    };

    return (
        <Modal
        id={theme}
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            ariaHideApp={false}
            style={{
                overlay: {
                    zIndex: 99999,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                },
                content: {
                    margin: "auto",
                    justifyContent: "center",
                    display: "flex",
                    backgroundColor: "transparent",
                    border: "none",
                    zIndex: 100000,
                    height: "300px",
                }
            }}
        >
            <form onKeyDown={handleKeyPress}>
                <div className={`${theme} modal-container`}>
                    <h2>Password Protected</h2>

                    <div className="manual-inputs">
                        <label htmlFor="value">Enter Password</label>
                        <input
                            id="value"
                            type="password"
                            className="input"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />

                    </div>

                    {error && <span style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px', color: 'red' }}>{error}</span>}

                    <div className="button-group">
                        <button className="add-button" onClick={handleSubmit}>
                            Submit
                        </button>
                        <button
                            className="close-button"
                            onClick={() => setIsOpen(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default RequestPassword;
